import React, { useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { fetchGooglePlaceDetails, fetchGoogleSuggestions } from '../services/googlePlaces';
import { getTodayDate, getMinDateForAge18 } from '../utils/formatData';
import { STATE_NAME_TO_ABBR } from '../utils/USStates';
// import Tooltip from 'bootstrap';
import '../App.css';

const FormField = ({
  name,
  label,
  type,
  options = [],
  required,
  colSpan = 6,
  colClass,
  formatPattern,
  backendErrors = [],
  maxlength,
  autocomplete,
  placeholder,
  helperText,
  labelIcon,
  validationPattern,
  validationMessage,
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSSN, setShowSSN] = React.useState(false);

  // const [localValue, setLocalValue] = useState('');
  const SSN_FIELDS = ['ssn', 'ssn_confirm', 'co_borrower_ssn', 'co_borrower_ssn_confirm'];
  const digitsOnly = ( s = '') => s.replace(/\D/g, '').slice(0,9);

  const [isFocused, setIsFocused] = React.useState(false);

  const form = useFormContext();
  if (!form) return null;

  const {
    register,
    setValue,
    formState: { errors, touchedFields, dirtyFields }
  } = form;

 

  // const hasError = !!(errors[name] || backendErrors.find((err) => err.path === name));
  const isTouched = touchedFields[name];
  // const isDirty = dirtyFields[name];

  const getInputClass = (base) => {
    if (errors[name]) return `${base} is-invalid`;
    if (isTouched && !errors[name]) return `${base} is-valid`;
    return base;
  };
  

  const getDateConstraints = () => {
    const today = getTodayDate();
    const ageLimit = getMinDateForAge18();
    const addressSince = form.watch('address_since');
    const employerSince = form.watch('employer_since');
    const coBorrowerEmployerSince = form.watch('co_borrower_employer_since');

    if (['dob', 'co_borrower_dob'].includes(name)) return { max: ageLimit };
    if (
      ['address_since', 'employer_since', 'co_borrower_employer_since', 'drivers_license_issue_date', 'co_borrower_drivers_license_issue_date', 'co_borrower_address_since'].includes(name)
    ) return { max: today };
    if (
      ['drivers_license_expire_date', 'co_borrower_drivers_license_expire_date', 'next_payment_date', 'next_payment_date_2', '' ].includes(name)
    ) return { min: today };

    if (['past_movein_date', 'past_moveout_date'].includes(name)) {
      return {
        max: addressSince ? new Date(addressSince).toISOString().split('T')[0] : today
      };
    }
    if (['past_hire_date', 'past_last_day_of_employment_date'].includes(name)) {
      return {
        max: employerSince ? new Date(employerSince).toISOString().split('T')[0] : today
      };
    }

    if (['co_borrower_past_hire_date', 'co_borrower_past_last_day_of_employment_date'].includes(name)) {
      return {
        max: coBorrowerEmployerSince ? new Date(coBorrowerEmployerSince).toISOString().split('T')[0] : today
      };
    }
    return {};
  };

  const formatPhoneNumber = (value) => {
    if (!value) return ''; // Handle empty input
    const cleaned = (value || '').replace(/[^\d]/g, '');
    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 6) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  };

  const formatSSN = (value) => {
    const cleaned = (value || '').replace(/[^\d]/g, '');
    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 5) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5, 9)}`;
  };

  const maskSSNFromDigits = (d) => {
    const n = d.length;
    if (n === 0) return '';
    if (n <= 3) return '*'.repeat(n);
    if (n <= 5) return `***-${'*'.repeat(n - 3)}`;
    return `***-**-${'*'.repeat(n - 5)}`;
  };

    const formatSSNFromDigits = (d) => {
      const s = d.slice(0, 9);
      if (s.length <= 3) return s;
      if (s.length <= 5) return `${s.slice(0, 3)}-${s.slice(3)}`;
      return `${s.slice(0, 3)}-${s.slice(3, 5)}-${s.slice(5)}`;
    };

  const formatCurrency = (value) => {
    const digits = (value || '').replace(/[^\d]/g, '');
    if (!digits) return '';
  
    const number = parseInt(digits, 10); // Treat the input as cents
    if (isNaN(number)) return '';
  
    return number.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };
  
  
  
  const currencyFields = [
    "monthly_income",
    "monthly_home_payment",
    "other_expenses",
    "current_monthly_payment",
    "current_payoff",
    "co_borrower_monthly_income",
    "co_borrower_monthly_home_payment",
    "co_borrower_other_expenses",
    "co_borrower_current_monthly_payment",
    "co_borrower_current_payoff",
    'co_borrower_gross_income',
   
  ];
  const phoneFields = [
    'phone_1',
    'employer_phone_1',
    'co_borrower_phone_1',
    'co_borrower_employer_phone_1',
  ];

  const basePrefix = name.replace(/address_1$/, '');
  const cityField = `${basePrefix}city`;
  const stateField = `${basePrefix}state`;
  const zipField = `${basePrefix}zip`;


  const renderField = () => {
    const commonProps = {
      className: getInputClass('form-control'),
      //  ...register(name, {
      //   required: required ? `${label || name} is required` : false,
      //   ...(validationPattern ? {
      //     pattern: {
      //       value: new RegExp(validationPattern),
      //       message: validationMessage || `${label || name} is invalid`,
      //     }
      //   } : {}),
      //  }),
      ...register(name),
      maxLength: phoneFields.includes(name) ? 12 : maxlength,
      placeholder: placeholder,
    };

    
  
    if (type === 'select') {
      const currentValue = form.watch(name) || '';
      return (
        <select
          {...commonProps}
          className={`${getInputClass('form-select')} ${currentValue === '' ? 'placeholder-active' : ''}`}
          value={currentValue}
        >
          <option value="" disabled>{placeholder || `Choose ${label}`}</option>
          {options.map((opt, idx) => (
            <option key={idx} value={opt.value || opt}>
              {opt.label || opt}
            </option>
          ))}
        </select>
      );
    }
  
    if (type === 'radio') {
      return (
        <div className="radio-group-container d-flex flex-wrap gap-4 align-items-center">
          {options.map((opt, idx) => (
            <div className="form-check d-flex align-items-center" key={idx}>
              <input
                className="form-check-input me-2"
                type="radio"
                id={`${name}_${idx}`}
                value={opt.value || opt}
                {...register(name)}
              />
              <label className="form-check-label m-0" htmlFor={`${name}_${idx}`}>
                {opt.label || opt}
              </label>
            </div>
          ))}
        </div>
      );
    }
  
    if (type === 'textarea') {
      return <textarea {...commonProps} rows="4" placeholder={placeholder || " "} />;
    }
  
    if (type === 'date') {
      const { min, max } = getDateConstraints();
      return <input {...commonProps} type="date" min={min} max={max} />;
    }
  
  // Replace your existing currency field handler with this:

// Replace your existing currency field handler with this:

// Replace your existing currency field handler with this:

if (currencyFields.includes(name)) {
  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field }) => {
        // Format value for display
        const formatForDisplay = (value) => {
          if (!value) return '';
          const num = parseFloat(value);
          if (isNaN(num)) return '';
          
          return num.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        };
        
        return (
          <input
            className={getInputClass('form-control')}
            type="text"
            value={isFocused ? (field.value || '') : formatForDisplay(field.value)}
            onChange={(e) => {
              const val = e.target.value;
              
              // Remove all non-numeric characters except decimal point
              const cleaned = val.replace(/[^\d.]/g, '');
              
              // Ensure only one decimal point
              const parts = cleaned.split('.');
              let formatted = parts[0];
              if (parts.length > 1) {
                // Limit to 2 decimal places
                formatted += '.' + parts[1].slice(0, 2);
              }
              
              // Store the clean numeric value
              field.onChange(formatted);
            }}
            onFocus={() => {
              setIsFocused(true);
            }}
            onBlur={() => {
              setIsFocused(false);
              // Ensure value has 2 decimal places when stored
              if (field.value && !isNaN(field.value)) {
                const num = parseFloat(field.value);
                field.onChange(num.toFixed(2));
              }
            }}
            placeholder={isFocused ? '0.00' : '$0.00'}
          />
        );
      }}
    />
  );
}
    
  // NEW: MASKED SSN HANDLER (runs before generic input)
  // if (SSN_FIELDS.includes(name)) {
  //   return (
  //     <Controller
  //       name={name}
  //       control={form.control}
  //       defaultValue=""
  //       render={({ field }) => {
  //         const rawDigits = digitsOnly(field.value);          // only the numbers (0..9), max 9
  //         const displayMasked = maskSSNFromDigits(rawDigits); // what we show to the user

  //         return (
  //           <input
  //             className={getInputClass('form-control')}
  //             type="text"
  //             value={displayMasked}
  //             inputMode="numeric"
  //             autoComplete="off"
  //             onKeyDown={(e) => {
  //               const allowNav = ['Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
  //               if (allowNav.includes(e.key)) return;

  //               if (e.key === 'Backspace') {
  //                 e.preventDefault();
  //                 const next = rawDigits.slice(0, -1);
  //                 field.onChange(formatSSNFromDigits(next)); // store real formatted value: 123-45-6789
  //                 return;
  //               }

  //               if (/^\d$/.test(e.key)) {
  //                 e.preventDefault();
  //                 if (rawDigits.length >= 9) return;
  //                 const next = rawDigits + e.key;
  //                 field.onChange(formatSSNFromDigits(next)); // store real formatted
  //                 return;
  //               }

  //               // Block everything else (letters, spaces, etc.)
  //               e.preventDefault();
  //             }}
  //             onPaste={(e) => {
  //               e.preventDefault();
  //               const pasted = digitsOnly(e.clipboardData.getData('text'));
  //               field.onChange(formatSSNFromDigits(pasted));
  //             }}
  //           />
  //         );
  //       }}
  //     />
  //   );
  // }

  if (SSN_FIELDS.includes(name)) {

  return (
    <Controller
      name={name}
      control={form.control}
      defaultValue=""
      render={({ field }) => {
        const rawDigits = digitsOnly(field.value); // only numbers
        const displayValue = showSSN
          ? formatSSNFromDigits(rawDigits) // show actual SSN
          : maskSSNFromDigits(rawDigits); // show masked

        return (
          <div className="position-relative">
            <input
              className={getInputClass("form-control")}
              type="text"
              value={displayValue}
              inputMode="numeric"
              autoComplete="off"
              onKeyDown={(e) => {
                const allowNav = ["Tab", "ArrowLeft", "ArrowRight", "Home", "End"];
                if (allowNav.includes(e.key)) return;

                if (e.key === "Backspace") {
                  e.preventDefault();
                  const next = rawDigits.slice(0, -1);
                  field.onChange(formatSSNFromDigits(next));
                  return;
                }

                if (/^\d$/.test(e.key)) {
                  e.preventDefault();
                  if (rawDigits.length >= 9) return;
                  const next = rawDigits + e.key;
                  field.onChange(formatSSNFromDigits(next));
                  return;
                }

                e.preventDefault(); // block letters/spaces
              }}
              onPaste={(e) => {
                e.preventDefault();
                const pasted = digitsOnly(e.clipboardData.getData("text"));
                field.onChange(formatSSNFromDigits(pasted));
              }}
            />

            {/* 👁 Eye icon toggle */}
            <button
              type="button"
              className="btn position-absolute top-50 end-0 translate-middle-y me-2 p-0 border-0 bg-transparent"
              onClick={() => setShowSSN((prev) => !prev)}
            >
              <i className={`fa ${showSSN ? "fa-eye" : "fa-eye-slash"}`} />
            </button>
          </div>
        );
      }}
    />
  );
}

    // Generic Input Handler
    return (
      <div className="position-relative">
        <input
          {...commonProps}
          type={type}
          value={form.watch(name) || ''}
          onChange={async (e) => {
            const val = e.target.value;
  
            if (phoneFields.includes(name)) {
              const formatted = formatPhoneNumber(val);
              setValue(name, formatted, { shouldValidate: true, shouldDirty: true });
              return;
            }
  
            if (
              ['ssn', 'ssn_confirm', 'co_borrower_ssn', 'co_borrower_ssn_confirm'].includes(name) &&
              formatPattern === '###-##-####'
            ) {
              setValue(name, formatSSN(val), { shouldValidate: true });
              return;
            }
  
            setValue(name, val, { shouldValidate: true, shouldTouch: true });
            form.trigger(name); // ensure Yup re-runs the conditional

  
            if (autocomplete === 'google' && name.endsWith('address_1') && val.length > 3) {
              const results = await fetchGoogleSuggestions(val);
              // console.log("Google suggestions:", results);
              setSuggestions(results || []);
              setShowDropdown((results && results.length > 0));
            }
          }}
          onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
          onFocus={() => setShowDropdown(name.endsWith('address_1') && autocomplete === 'google')}
        />
  
        {showDropdown && name.endsWith('address_1') && suggestions.length > 0 && (
          <ul className="list-group position-absolute z-3 w-100 mt-1" style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {suggestions.map((pred, idx) => (
            <li
              key={pred.place_id}
              className="list-group-item list-group-item-action"
              onClick={async () => {
              const details = await fetchGooglePlaceDetails(pred.place_id);
              if (!details) return;

              const comps = details.address_components;

              const getComp = (types, useShort = false) => {
                const comp = comps.find((c) => types.every((t) => c.types.includes(t)));
                if (!comp) return "";
                return useShort ? comp.short_name : comp.long_name;
              };

              // Street from details
              const street = [
                getComp(["street_number"]),
                getComp(["route"])
              ].filter(Boolean).join(" ");

              // City fallback: prefer what user saw in suggestion
              const cityFromPrediction = pred.structured_formatting?.secondary_text?.split(",")[0] || "";
              const cityFromDetails =
                getComp(["locality"]) ||
                getComp(["sublocality"]) ||
                getComp(["administrative_area_level_2"]);
              const city = cityFromPrediction || cityFromDetails;

              // State + Zip from details
              const stateAbbr = getComp(["administrative_area_level_1"], true);
              const zip = getComp(["postal_code"]);

              setValue(name, street, { shouldValidate: true });
              setValue(cityField, city);
              setValue(stateField, stateAbbr);
              setValue(zipField, zip);
              setShowDropdown(false);
            }}

            >
              {pred.description}
            </li>
          ))}
          </ul>
        )}
      </div>
    );
  };
  
  const fieldErrors = errors[name] || backendErrors.find((err) => err.path === name);
  const responsiveCol = `col-xl-${colSpan} col-md-6 col-sm-12`;

  return (
    <div className={`form-group mb-3 ${responsiveCol}`}>
    
    <label htmlFor={name} className="form-label d-flex align-items-center gap-2">
      {typeof label === 'function' ? label(form.getValues()) :label}
      {required && <span className="text-danger">*</span>}
      {labelIcon && (
        <span
          className="info-icon"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-trigger="click focus"
          title={typeof labelIcon === 'string' ? 'More info' : labelIcon.tooltip}
        >
          <i className={typeof labelIcon === 'string' ? labelIcon : labelIcon.icon} style={{ fontSize: '0.85rem', cursor: 'pointer', color: '#666' }}></i>
        </span>
      )}
    </label>


      {renderField()}
      {helperText && (
        <small className="form-text text-muted">
          {helperText}
        </small>
      )}
      {fieldErrors && (
        <p className="text-danger" style={{ fontSize: '0.875rem' }}>
          {fieldErrors.message || fieldErrors.msg || 'This field is required'}
        </p>
      )}
    </div>
  );
};

export default FormField;
